import React, {ReactNode} from 'react';

export class Form extends React.PureComponent<{ children?: ReactNode }> {
	render() {
		return <form className='form-horizontal' onSubmit={(e) => e.preventDefault()}>
			{this.props.children}
		</form>;
	}
}
